module.exports = __webpack_public_path__ + "static/media/homeBuilders.b3127182.svg";